
import {
  createRouter,
  createWebHashHistory,
} from "vue-router";

import Layout from "@/layout/index.vue";
import login from "@/views/login/login.vue";
import superadminLogin from "@/views/login/superadmin-login.vue";
import { tenantRoutes } from "./modules/routing.js";
import { platformRoutes } from "./modules/platformRouting.js";
import { enablePlatform } from "@/utils/deployConfig.js";
import {
  hasPortalSession,
  migrateLegacySessionIfNeeded,
  resolveLoginPortalAccess,
  activatePortalSession,
  PORTAL_PLATFORM,
  PORTAL_TENANT,
} from "@/utils/authSession.js";
import { getLoginUser } from "@/utils/loginUser.js";
import { isPathAllowedForUser } from "@/utils/adminMenuPermission.js";

const routes = [
  // ── 租户后台 ──────────────────────────────────────────
  {
    path: "/",
    component: Layout,
    meta: { portal: PORTAL_TENANT },
    redirect: "/home",
    children: tenantRoutes,
  },
  {
    path: "/login",
    name: "login",
    component: login,
    meta: { portal: PORTAL_TENANT, public: true },
  },

  // ── 超管后台（SaaS 模式）────────────────────────────────
  ...(enablePlatform ? [
    {
      path: "/platform",
      component: Layout,
      meta: { portal: PORTAL_PLATFORM },
      redirect: "/platform/tenants",
      children: platformRoutes,
    },
    {
      path: "/superadmin/login",
      name: "superadminLogin",
      component: superadminLogin,
      meta: { portal: PORTAL_PLATFORM, public: true },
    },
  ] : []),

  // 未知路径 → 租户登录（避免落到超管页）
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const portal = to.meta.portal || (to.path.startsWith("/platform") || to.path.startsWith("/superadmin")
    ? PORTAL_PLATFORM
    : PORTAL_TENANT);

  document.title = portal === PORTAL_PLATFORM
    ? `晋辉智机通 · 平台管理`
    : "晋辉智机通";

  migrateLegacySessionIfNeeded();

  if (!enablePlatform && portal === PORTAL_PLATFORM) {
    next("/login");
    return;
  }

  if (to.meta.public) {
    const { allowLoginPage, redirectTo } = resolveLoginPortalAccess(to.path);
    if (!allowLoginPage && redirectTo) {
      next(redirectTo);
      return;
    }
    next();
    return;
  }

  if (portal === PORTAL_PLATFORM) {
    if (!hasPortalSession(PORTAL_PLATFORM)) {
      next("/superadmin/login");
      return;
    }
    activatePortalSession(PORTAL_PLATFORM);
    next();
    return;
  }

  if (!hasPortalSession(PORTAL_TENANT)) {
    next("/login");
    return;
  }

  if (!isPathAllowedForUser(to.path, getLoginUser(PORTAL_TENANT))) {
    next("/home");
    return;
  }

  activatePortalSession(PORTAL_TENANT);
  next();
});


export default router;
